
import isk from '@/functions/isk'
import simpleDateRange from '@/functions/simpleDateRange'
import isMatch from 'date-fns/isMatch'
import useCloudinaryMediaLibrary from '#/useCloudinaryMediaLibrary'

import { format } from 'date-fns'
import { defineComponent, computed, ref, watch, watchEffect } from 'vue'
import { unixTime, repeatString, copyToClipboard } from '@/modules/Geri'

import Button      from '@@/gui/Button.vue'
import { TextField } from '@@/gui/fields'

export default defineComponent({
	name: 'TripChimpPage',

	components: {
		Button,
		TextField
	},

	setup () {
		const url         = ref<string>('')
		const city        = ref<string>('')
		const country     = ref<string>('')
		const hotel       = ref<string>('')
		const stars       = ref<number>(3)
		const room        = ref<string>('')
		const mealplan    = ref<string>('')
		const outbound    = ref<string>('')
		const inbound     = ref<string>('')
		const price       = ref<string>('0')
		const adults      = ref<number>(1)
		const children    = ref<number>(0)
		const origin      = ref<string>('KEF')
		const destination = ref<string>('')
		const image       = ref<string>('')

		function updateDate (date: string) {
			return isMatch(date, 'yyyy-MM-dd') ? new Date(date) : new Date()
		}
		const outDate = computed<Date>(() => updateDate(outbound.value))
		const inDate  = computed<Date>(() => updateDate(inbound.value))

		const widget = useCloudinaryMediaLibrary(image)

		watchEffect(() => console.log(city.value))
		
		function addImage () {
			widget.show()
		}
		function formatDate (date: Date) {
			return format(date, 'dd.MM.yyyy')
		}
		function onClick () {
			copyToClipboard(template.value)
			alert('Kubbur kópíraður!')
		}

		const template = computed<string>(() => {
			const repeatIcon = ''

			return `
			<a href="${url.value}" 
				style="display: block; 
					text-decoration: none; 
					height:530px; 
					font-family: 'DIN Next LT Pro', 'Helvetica Neue', Arial, sans-serif !important; 
					padding: 8px;
					font-stretch: condensed;"
			>
				<table style="background:#fff; width: 100%; color: #000; ">
					<tbody>
						<tr>
							<td style="font-size: 24px; 
								color: #fff; 
								font-weight: bolder; 
								text-transform: uppercase;
								text-shadow: 2px 1px 4px #666;"
							>
								<div style="padding-top: 200px; background-color: #ccc; background-size: cover; background-image: url(${image.value});">
									<div style="padding: 0 12px;">${city.value}</div>
									<div style="padding: 0 12px 12px;">${simpleDateRange([ outDate.value, inDate.value ])}</div>
								</div>
							</td>
						</tr>
						<tr>
							<td style="padding: 12px; text-transform: uppercase; font-stretch: condensed; line-height: 1.5em;">
								<div>
									<span style="font-weight: bold;">
										${hotel.value} ${stars.value}★
									</span>
									<br/>
									${city.value} / ${country.value}
									<br/>
									<img style="height: 20px; width: auto; display: inline-block;" src="https://hermes.fitravel.info/airplane.png"/> ${origin.value} — ${destination.value}
									<br/>
									${formatDate(outDate.value)} - ${formatDate(inDate.value)}
									<br/>
									${room.value}
									<br/>
									${mealplan.value}
									<br/>
									<span style="color: #f3000c; font-weight: bolder; padding: 6px 0; font-size: 21px;">
										${isk(parseInt(price.value))} á mann*
									</span>
									<br/>
									M.V. ${repeatString(
										'<img style="height: 30px; width: auto; display: inline-block;" src="https://hermes.fitravel.info/adult.png"/>'
									)(adults.value)}${repeatString(
										'<img style="height: 30px; width: auto; display: inline-block;" src="https://hermes.fitravel.info/child.png"/>'
									)(children.value)}
								</div>
								<div style="text-align: right;">
									<span style="display: inline-block; background: #f3000c; color: #fff; padding: 8px 12px; border-radius: 10px;">
										BÓKAÐU HÉR
									<span>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</a>
		`
		})

		return {
			url,
			template,
			city,
			country,
			hotel,
			stars,
			room,
			mealplan,
			outbound,
			inbound,
			price,
			adults,
			children,
			origin,
			destination,
			addImage,
			image,
			onClick
		}
	}
})
